import NextImage from 'components/image/image';
import { Typography } from 'components/typography/typography-component';
import Link from 'next/link';
import React, { useState } from 'react';

export default function ReactSquadPricing() {
  const [active] = useState([
    {
      title: 'Find Talent in 24 Hours',
      description:
        "Within 24 hours you'll be ready to start working with your matched talent",
    },
    {
      title: 'Longterm Collaborations',
      description:
        'We support our customers as long as they need us. 50% of our engagements are >12 months.',
    },
    {
      title: 'Cancel Anytime',
      description:
        'Pay as you go, rolling weekly contract with no minimum commitment!',
    },
    {
      title: 'Flexible Contracts',
      description:
        'Whether your requirement is part-time, full-time or you need to outsource an entire project, we can offer you a customized solution.',
    },
    {
      title: 'Expert Engineers',
      description:
        'All of our developers were hired and get personally mentored by a Senior Engineer from a Silicon Valley Unicorn.',
    },
    {
      title: 'Time-Zone Overlap',
      description:
        'Our globally distributed talent pool is available to you with a working time overlap of 4 hours daily, for easy collaboration.',
    },
  ]);

  return (
    <div className="flex justify-center py-12" id="pricing">
      <div className="flex w-11/12 flex-col justify-center gap-8 py-20 lg:flex-row">
        <div className="justify-center lg:w-[35%]  ">
          <div className="w-full rounded-xl bg-white">
            <div className="h-[592px]">
              <div className="flex h-[35%] w-[100%] flex-col justify-center rounded-tl-2xl rounded-tr-2xl bg-gradient-to-b from-[#FFC400C2] to-[#FF6F00]">
                <Typography variant="h2" className="text-center text-white">
                  80$/hour
                </Typography>
                <Typography className="py-2 text-center text-white">
                  per hour
                </Typography>
                <div className="flex justify-center">
                  <button className="mt-4 rounded-3xl border-2 border-white">
                    <Typography className="px-10 py-2 text-center font-semibold text-white">
                      <Link
                        href="https://calendly.com/nikolas-earlynode/reactsquad-io-chat-via-boteatbrain?month=2023-07"
                        target={'_blank'}
                      >
                        {"Let's Talk"}
                      </Link>
                    </Typography>
                  </button>
                </div>
              </div>
              <div className="h-[65%] w-[100%]">
                <div className="mx-4 my-4 flex items-center">
                  <NextImage
                    src={'/people.svg'}
                    width={15}
                    height={15}
                    alt="icon"
                    unoptimized
                    className="ml-4 mr-3"
                  />
                  <Typography className="">
                    Specialized developers who are 100% focused on React.js
                  </Typography>
                </div>
                <div className="mx-4 my-4 flex items-center">
                  <NextImage
                    src={'/security.svg'}
                    width={15}
                    height={15}
                    alt="icon"
                    unoptimized
                    className="ml-4 mr-3"
                  />
                  <Typography className="">
                    Fully-vetted talents who are fulltime employees at
                    ReactSquad
                  </Typography>
                </div>

                <Typography
                  variant="paragraph"
                  className="ml-8 mt-6 font-semibold"
                >
                  Includes
                </Typography>
                <div className="mx-4 my-4 flex items-center">
                  <NextImage
                    src={'/check.svg'}
                    width={10}
                    height={10}
                    alt="icon"
                    unoptimized
                    className="ml-4 mr-3"
                  />
                  <Typography className="">30-day risk-free trial!</Typography>
                </div>
                <div className="mx-4 my-4 flex items-center">
                  <NextImage
                    src={'/check.svg'}
                    width={10}
                    height={10}
                    alt="icon"
                    unoptimized
                    className="ml-4 mr-3"
                  />
                  <Typography className="">Flexible contracts</Typography>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-[65%]">
          <div>
            <Typography variant="h3" className="font-inter font-extrabold">
              Simple pricing to suit
              <br />
              <span className="bg-gradient-to-r from-[#FF8F00] to-[#FFC400] bg-clip-text text-fill-transparent">
                fast paced startups
              </span>
            </Typography>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {active.map((item, index) => (
              <div
                key={index}
                className="h-full w-full rounded-xl bg-white px-4 py-8 sm:h-[200px]"
              >
                <Typography
                  variant="paragraph"
                  className="text-left font-semibold"
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="paragraph"
                  className="mt-5 text-left text-sm"
                >
                  {item.description}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
